import { IObjectAudit } from "../../../models"

export interface IFavoriteDocument {
    Id: string
    AccountId: string
    UserId: string
    ObjectId: string
    FavoriteType: EFavoriteType
    Deleted: boolean
    ObjectAudit: IObjectAudit
    TicksSinceChange: number
}

export enum EFavoriteType {
    Job = 0,
    Employee = 1,
    Client = 2,
    Device = 3,
}

export interface IFavoriteParams {
    FavoriteType: EFavoriteType
    ObjectIds: string[]
}